import {VerticalAlign, RichTextTextStyle} from '@gongxigames/framework/core/fragments/display/richText/TextStyle';
import {Container, Sprite, Text, TextStyleAlign} from 'pixi.js';

export type LineItemType = Text | Container | Sprite;

export type LineItem = {
    item: LineItemType;
    height: number;
    descent: number;
    // for ram and video memory cleanup
    toDestroy: boolean;
};

export class Line {
    elements: LineItem[] = [];
    width = 0;
    descent = 0;
    align: TextStyleAlign = 'left';
    verticalAlign: VerticalAlign = 'top';

    constructor(
        public height: number,
        public style: RichTextTextStyle
    ) {
        if (style.align) {
            this.align = style.align;
        }

        if (style.verticalAlign) {
            this.verticalAlign = style.verticalAlign;
        }
    }

    public addToLine(item: Text | Container, width: number, height: number, descent: number, toDestroy = false): void {
        this.height = Math.max(this.height, height);
        this.descent = Math.max(this.descent, descent);
        this.width += width;
        this.elements.push({item, height, descent, toDestroy});

        if (!(item instanceof Text)) {
            return;
        }

        if (item.style.align) {
            this.align = item.style.align;
        }

        if ((item.style as RichTextTextStyle).verticalAlign) {
            this.verticalAlign = (item.style as RichTextTextStyle).verticalAlign;
        }
    }

    public render(): void {
        let deltaX = 0;

        if (this.align === 'right') {
            deltaX = -this.width;
        } else if (this.align === 'center') {
            deltaX = -this.width / 2;
        }

        this.elements.forEach(element => {
            element.item.x += deltaX;                           // horizontal align
            element.item.y += this.height - element.height + element.descent - this.descent;     // vertical align
        });
    }
}
